import type { FC } from "react"
import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"
import {
  Box,
  Button,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControlLabel,
  Typography,
} from "@mui/material"
import ConstructionIcon from "@mui/icons-material/Construction"
import { useAppDispatch, useAppSelector } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  setAutoProActiveStep,
  setGoAutoProcesses,
  setCurArch,
  setOpenBiteReg,
  setOpenRelabel,
  setOpenSpaceCorrection,
  setStageShowType,
  setOpenOrientation,
  setIsOpenModelCheck,
} from "@/UDTreat/udTreatSlice"
import {
  viewControlInTreatment,
  wasmModule,
  caseManagement,
  EArchType,
  relabel,
} from "@/gluelayer"
import { relabelModule } from "@/gluelayer/core/modules/relabel"
import { resegmentationModule } from "@/gluelayer/core/modules/resegmentation/resegmentationModule"
import { uploadCaseZips } from "@/core/app/slices/clinical/clinicalThunkApi"
import { useParams } from "react-router-dom"
import { setIsShowProgress } from "@/core/app/slices/clinical/clinicalSlice"
const AutoModelCheckStep: FC = () => {
  const { t } = useTranslation("common")
  const dispatch = useAppDispatch()
  const { autoProActiveStep, curArch, openBiteReg } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const {
    clinicalSettings: { NumberSystem },
  } = useAppSelector((state: RootState) => state.userService)
  const { caseId, patientId } = useParams()
  const [sameLabelDlg, setSameLabelDlg] = useState(false)
  const { setstageShowTypeNormalCallback } = relabel
  const [showSaveButton, setShowSaveButton] = useState(false)

  const handleNext = () => {
    if (relabelModule.IsRelabelModuleOpened()) {
      console.log("Relabel module is opened")
      if (
        relabelModule.IsExistSameLabelForSingleJaw(0) ||
        relabelModule.IsExistSameLabelForSingleJaw(1)
      ) {
        setSameLabelDlg(true)
        return
      }

      relabelModule.openRelabelModule(false)
      if (relabelModule.IsRelabelModuleOpened()) {
        dispatch(setIsShowProgress(true))

        // 这是做了更改后需要和服务器交互等待时间
        setstageShowTypeNormalCallback(() => {
          dispatch(setStageShowType("normal"))
          dispatch(setAutoProActiveStep(autoProActiveStep + 1))
          dispatch(setIsShowProgress(false))
        })
      } else {
        dispatch(setAutoProActiveStep(autoProActiveStep + 1))
        dispatch(setStageShowType("normal"))
      }

      return
    }

    closeFunctions()
    if (autoProActiveStep < 4) {
      dispatch(setAutoProActiveStep(autoProActiveStep + 1))
    }
    if (autoProActiveStep === 4) {
      // finish
      // upload zips bulk1 bulk2
      caseManagement.getCaseFiles(["bulk1", "bulk2"]).then((r) => {
        const zips = []
        if (r) {
          for (const k in r) {
            zips.push({
              fileName: k,
              file: r[k],
            })
          }

          dispatch(
            uploadCaseZips({
              zips,
              patientId,
              caseId,
            }),
          ).then(({ payload }) => {
            if (zips.length === payload.length) {
              for (let i = 0; i < payload.length; i++) {
                if (payload[i].status !== 200) {
                  return
                }
              }
              console.log("finish")
              dispatch(setGoAutoProcesses(false))
              wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
            }
          })
        }
      })
    }
  }
  const handleBack = () => {
    if (relabelModule.IsRelabelModuleOpened()) {
      console.log("Relabel module is opened")
      if (
        relabelModule.IsExistSameLabelForSingleJaw(0) ||
        relabelModule.IsExistSameLabelForSingleJaw(1)
      ) {
        setSameLabelDlg(true)
        return
      }

      relabelModule.openRelabelModule(false)
      if (relabelModule.IsRelabelModuleOpened()) {
        dispatch(setIsShowProgress(true))

        // 这是做了更改后需要和服务器交互等待时间
        setstageShowTypeNormalCallback(() => {
          dispatch(setStageShowType("normal"))
          dispatch(setAutoProActiveStep(autoProActiveStep - 1))
          dispatch(setIsShowProgress(false))
        })
      } else {
        dispatch(setAutoProActiveStep(autoProActiveStep - 1))
        dispatch(setStageShowType("normal"))
      }

      return
    }
    closeFunctions()

    if (autoProActiveStep > 0) {
      dispatch(setAutoProActiveStep(autoProActiveStep - 1))
    }
  }

  const closeFunctions = () => {
    if (wasmModule.moduleManager.GetModuleOrientationAdjustment() !== null) {
      console.log("SwitchModuleOrientationAdjustment(false)")
      wasmModule.moduleManager.SwitchModuleOrientationAdjustment(false)
      dispatch(setStageShowType("normal"))
    }
    if (wasmModule.moduleManager.GetSpaceCorrectionModule() !== null) {
      console.log("ToggleSpaceCorrect(false)")
      wasmModule.moduleManager.ToggleSpaceCorrect(false)
      dispatch(setOpenSpaceCorrection(false))
      dispatch(setStageShowType("normal"))
    }
    if (resegmentationModule.isResegmentationModuleOpened()) {
      console.log("resegmentationModule.openResegmentationModule(false)")
      resegmentationModule.openResegmentationModule(false)
      dispatch(setStageShowType("normal"))
    }
    if (openBiteReg) {
      dispatch(setOpenBiteReg(false))
      dispatch(setStageShowType("normal"))
    }

    dispatch(setCurArch("all"))
    viewControlInTreatment.setViewType("front")
    setShowSaveButton(false)
    // setTitle("")
  }

  const saveOrientationButton = showSaveButton ? (
    <Button
      variant="contained"
      color="primary"
      sx={{
        position: "absolute",
        top: "30%",
        right: 100,
        // transform: "translateX(-50%)",
        zIndex: 1100,
      }}
      onClick={() => {
        const oriModule =
          wasmModule.moduleManager.GetModuleOrientationAdjustment()
        oriModule.SaveOrientation()
      }}
    >
      Save
    </Button>
  ) : null

  useEffect(() => {
    console.log("autoProActiveStep", autoProActiveStep)

    if (!wasmModule.isInit) return

    switch (autoProActiveStep) {
      case 0:
        const seg = async () => {
          if (curArch === "all") {
            await dispatch(setCurArch("up"))
          }
          console.log("curArch: ", curArch)
          resegmentationModule.openResegmentationModule(true)
        }
        seg()

        break
      case 1:
        if (
          relabelModule.IsExistSameLabelForSingleJaw(0) ||
          relabelModule.IsExistSameLabelForSingleJaw(1)
        ) {
          console.log("Same label exists")
          return
        }
        const relabel = async () => {
          viewControlInTreatment.zoomWithValueInTreatment(1)
          //if (wasmModule.moduleManager.GetSplitScreenModule() === null) {
          //if (curArch === "all") await dispatch(setCurArch("up"))
          //}
          const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
          const hasLower = wasmModule.getArchModel(EArchType.LowArch)
          if (hasUpper && hasLower) {
            viewControlInTreatment.showArchMode("all")
            wasmModule.statusController.SplitScreenDisplay(false)
            viewControlInTreatment.showArchMode("up")
            await dispatch(setCurArch("up"))
          }
          //if (curArch === "all") await dispatch(setCurArch("up"))
          relabelModule.numberSystem = NumberSystem
          relabelModule.openRelabelModule(true)
          if ((window as any).pulloutCallback()) {
            ;(window as any).pulloutCallback()
          }
          // await dispatch(setStageShowType(""))
          if (relabelModule.IsRelabelModuleOpened()) {
            await dispatch(setOpenRelabel(true))
            if ((window as any).treatment.RelabelViewZoomCallback) {
              ;(window as any).treatment.RelabelViewZoomCallback(
                relabelModule.zoomValue,
              )
            }
          }
        }

        relabel()
        break
      case 2:
        dispatch(setOpenBiteReg(true))
        break
      case 3:
        dispatch(setStageShowType(""))
        const hasUpper = wasmModule.getArchModel(EArchType.UpArch)
        const hasLower = wasmModule.getArchModel(EArchType.LowArch)
        if (hasUpper && hasLower) {
          viewControlInTreatment.showArchMode("all")
          wasmModule.statusController.SplitScreenDisplay(false)
          viewControlInTreatment.showArchMode("up")
        }
        dispatch(setCurArch("up"))
        wasmModule.moduleManager.ToggleSpaceCorrect(true)
        dispatch(setOpenSpaceCorrection(true))
        break
      case 4:
        dispatch(setOpenOrientation(true))
        setShowSaveButton(true)
        viewControlInTreatment.setViewType("front")
        wasmModule.moduleManager.SwitchModuleOrientationAdjustment(true)
        break
      default:
    }
  }, [autoProActiveStep])
  return (
    <>
      <Box
        sx={{
          width: "100%",
          height: "40px",
          position: "absolute",
          bottom: "20px",
          // background: "red",
          display: "flex",
          justifyContent: "center",
        }}
      >
        <Button
          disabled={autoProActiveStep === 0}
          onClick={handleBack}
          sx={{ width: "100px", marginRight: "200px" }}
          variant="contained"
        >
          {"Back"}
        </Button>
        <Button
          onClick={handleNext}
          sx={{ width: "100px" }}
          variant="contained"
        >
          {autoProActiveStep === 4 ? "Finish" : "Next"}
        </Button>
        <Box
          sx={{
            position: "absolute",
            left: "calc(50% + 300px)",
            top: "-10px",
            display: autoProActiveStep === 4 ? "block" : "none",
          }}
        >
          <FormControlLabel
            control={<Checkbox />}
            label={
              <Box>
                <Typography
                  variant="body1"
                  component="span"
                  display="inline"
                  style={{ color: "#fff" }}
                >
                  Don't run checks automatically next time. I will check and fix
                  individually from the tools set
                  <ConstructionIcon
                    sx={{ marginLeft: "12px" }}
                    color={"primary"}
                  ></ConstructionIcon>
                </Typography>
              </Box>
            }
          />
        </Box>
      </Box>

      <Dialog open={sameLabelDlg}>
        <DialogTitle id="alert-dialog-title">{"uDesign Cloud"}</DialogTitle>
        <DialogContent>{"There are duplicates,please relabel!"}</DialogContent>
        <DialogActions>
          <Button
            onClick={() => setSameLabelDlg(false)}
            autoFocus
            sx={{ textTransform: "samelabel" }}
            size="medium"
            color="primary"
            variant="contained"
          >
            OK
          </Button>
        </DialogActions>
      </Dialog>
      {saveOrientationButton}
    </>
  )
}
export default AutoModelCheckStep
